'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _actionBar = require('./action-bar');

var _actionBar2 = _interopRequireDefault(_actionBar);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.error.title'
});

var _ref2 = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.error.header'
});

var _ref3 = _jsx(_reactIntl.FormattedMessage, {
    id: 'signModal.error.body'
});

var ErrorTab = _react2['default'].createClass({
    displayName: 'ErrorTab',


    propTypes: {
        'app': _react2['default'].PropTypes.object.isRequired,
        'type': _react2['default'].PropTypes.string.isRequired,
        'onInsert': _react2['default'].PropTypes.func.isRequired,
        'onClose': _react2['default'].PropTypes.func.isRequired,
        'onError': _react2['default'].PropTypes.func.isRequired,
        'onContinue': _react2['default'].PropTypes.func,
        'isSelected': _react2['default'].PropTypes.bool.isRequired,
        'deviceOrientation': _react2['default'].PropTypes.string.isRequired,
        'screenSize': _react2['default'].PropTypes.string.isRequired,
        'locales': _react2['default'].PropTypes.array.isRequired,
        'messages': _react2['default'].PropTypes.object.isRequired,
        'isMobile': _react2['default'].PropTypes.bool.isRequired,
        'error': _react2['default'].PropTypes.object
    },

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'error': new Error('Unknown error')
        };
    },

    getInitialState: function getInitialState() {
        return {
            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS
        };
    },

    componentDidMount: function componentDidMount() {},

    componentDidUpdate: function componentDidUpdate() {},

    //  ----  BEHAVIOR  -----------------------------------

    onContinue: function onContinue() {
        this.resetTab();
        this.props.onContinue();
    },

    resetTab: function resetTab() {},

    //  ----  RENDERING  ----------------------------------

    render: function render() {

        var inputClasses = {
            'm-sign-modal--tabs--error--input': true
        };
        var classes = {
            'm-sign-modal--tabs--error': true
        };
        var containerClasses = {
            'm-sign-modal--tabs--tab': true,
            'is-selected': this.props.isSelected
        };
        var errorClasses = {
            'm-sign-modal--tabs--error-content': true
        };

        var errorMessage = this.props.error.message || '';

        return _jsx('div', {
            className: (0, _classnames2['default'])(containerClasses)
        }, void 0, _jsx('span', {
            className: 'm-sign-modal--tabs--tab-title'
        }, void 0, _ref), _jsx('div', {
            className: (0, _classnames2['default'])(classes)
        }, void 0, _jsx('div', {
            className: (0, _classnames2['default'])(inputClasses)
        }, void 0, _jsx('div', {
            className: 'm-sign-modal--tabs--content'
        }, void 0, _jsx('div', {
            className: (0, _classnames2['default'])(errorClasses)
        }, void 0, _jsx('h1', {}, void 0, _ref2), _jsx('p', {}, void 0, _ref3), _jsx('p', {}, void 0, errorMessage))))), _react2['default'].createElement(_actionBar2['default'], _extends({}, this.props, {
            type: this.props.type,
            isMobile: this.props.isMobile,
            locales: this.props.locales,
            messages: this.props.messages,
            onInsert: this.props.onInsert,
            onClose: this.props.onClose,
            continueInsteadOfInsert: true,
            onContinue: this.onContinue })));
    }
});

module.exports = ErrorTab;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/error-tab.jsx
 ** module id = 680
 ** module chunks = 0
 **/